module.exports = __webpack_public_path__ + "static/media/test18_2.88eb1f2e.png";